import { render, staticRenderFns } from "./CambiaPassModal.vue?vue&type=template&id=4d6868be&"
import script from "./CambiaPassModal.vue?vue&type=script&lang=js&"
export * from "./CambiaPassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports